import React from "react";
import type { TFunction } from "i18next";
import IconRedAlert from "~/components/Icons/alert-triangle";
import s from "./Cells.less";

interface AnswerStatusCellProps {
  status?: string | null;
  hasPunishment?: boolean;
  t: TFunction;
  translationPrefix?: string;
}

export const AnswerStatusCell: React.FC<AnswerStatusCellProps> = ({
  status,
  hasPunishment,
  t,
  translationPrefix = "violationsTable",
}) => {
  if (status === null || status === undefined || status === "") {
    return <span>-</span>;
  }

  return (
    <div className={s.statusWrapper}>
      {hasPunishment && <IconRedAlert />}
      <div className={s.status}>{t(`${translationPrefix}.${status}`)}</div>
    </div>
  );
};
